module.exports = __webpack_public_path__ + "media/assets/images/confinus-avatar-c7c61e27bcb589164e6db22c7d6dccf0.png";